import React from 'react';
import { workProcess } from '../data/mockData';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import MobileSlider from './MobileSlider';

const ProcessStep = ({ step, index, noAnimation = false }) => {
  const anim = useScrollAnimation({ threshold: 0.2 });
  const delay = index + 1;

  return (
    <div ref={noAnimation ? undefined : anim.ref} data-testid={`process-step-${step.id}`} className={`relative ${noAnimation ? '' : `scroll-fade-up scroll-delay-${delay}`} ${noAnimation || anim.isVisible ? 'scroll-visible' : ''}`}>
      <div className="text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-[#111827] text-white font-black text-xl mb-5" style={{ fontFamily: "'Outfit', sans-serif" }}>
          {step.step}
        </div>
        <h3 className="text-base font-black tracking-tighter text-[#111827] mb-2 uppercase" style={{ fontFamily: "'Outfit', sans-serif" }}>
          {step.title}
        </h3>
        <p className="text-sm text-[#4B5563] leading-relaxed max-w-[250px] mx-auto">
          {step.description}
        </p>
      </div>

      {/* Connector */}
      {index < 2 && (
        <div className="hidden lg:block absolute top-8 left-[calc(100%_-_8px)] w-[calc(100%_-_64px)]" style={{ left: 'calc(50% + 40px)', width: 'calc(100% - 80px)' }}>
          <div className="h-0.5 bg-[#E5E7EB] relative">
            <div className="absolute right-0 top-1/2 -translate-y-1/2 w-2 h-2 bg-[#FF1010] rotate-45" />
          </div>
        </div>
      )}
    </div>
  );
};

const HowWeWorkSection = () => {
  const header = useScrollAnimation({ threshold: 0.2 });

  return (
    <section id="process" data-testid="process-section" className="py-24 md:py-32 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-8 relative z-10">
        <div ref={header.ref} className={`text-center max-w-2xl mx-auto mb-16 scroll-fade-up ${header.isVisible ? 'scroll-visible' : ''}`}>
          <span className="text-xs font-bold uppercase tracking-widest text-[#FF1010] block mb-3">How It Works</span>
          <h2 className="text-3xl sm:text-4xl font-black tracking-tighter text-[#111827] mb-4 uppercase" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Three Steps. That's It.
          </h2>
          <p className="text-base text-[#4B5563] leading-relaxed">
            We made trademark registration simple. You tell us your brand, we handle the rest.
          </p>
        </div>

        {/* Desktop grid */}
        <div className="hidden sm:grid sm:grid-cols-3 gap-10 lg:gap-8 relative">
          {workProcess.map((step, index) => (
            <ProcessStep key={step.id} step={step} index={index} />
          ))}
        </div>

        {/* Mobile slider */}
        <div className="sm:hidden">
          <MobileSlider>
            {workProcess.map((step, index) => (
              <ProcessStep key={step.id} step={step} index={index} noAnimation />
            ))}
          </MobileSlider>
        </div>
      </div>
    </section>
  );
};

export default HowWeWorkSection;
